module.exports = __webpack_public_path__ + "img/mobile_map_brasov.7ba6ad1b.svg";